import { useEffect, useRef, useState } from 'react';

/**
 * Whether to show a loading indicator for `on`: only once it has lasted
 * `delay` ms, so a quick render never flashes one, and then for at least
 * `min` ms, so one that does show doesn't blink away.
 */
export function useDelayed(on, { delay = 300, min = 400 } = {}) {
  const [shown, setShown] = useState(false);
  const since = useRef(0);
  useEffect(() => {
    if (on && !shown) {
      const timer = window.setTimeout(() => {
        since.current = performance.now();
        setShown(true);
      }, delay);
      return () => window.clearTimeout(timer);
    }
    if (!on && shown) {
      const left = min - (performance.now() - since.current);
      if (left <= 0) {
        setShown(false);
        return undefined;
      }
      const timer = window.setTimeout(() => setShown(false), left);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [on, shown, delay, min]);
  return shown;
}
